import { render, staticRenderFns } from "./gift-auto-exchange.vue?vue&type=template&id=97b4dab6&scoped=true&"
import script from "./gift-auto-exchange.vue?vue&type=script&lang=js&"
export * from "./gift-auto-exchange.vue?vue&type=script&lang=js&"
import style0 from "./gift-auto-exchange.vue?vue&type=style&index=0&id=97b4dab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4dab6",
  null
  
)

export default component.exports